import { parseError } from "@/lib/parse-error";

const DOMAIN_SETUP_MESSAGE =
  "Your clinic does not have a verified transactional email domain yet. Set up an email domain before sending custom emails.";

function formatEmailErrorMessage(message: string): string {
  if (
    message.includes("SystemEmailService") ||
    message.includes("does not have a verified email domain") ||
    // Reply/draft/send paths raise NoDomainConfiguredError with this wording.
    message.includes("No verified Mailgun domain")
  ) {
    return DOMAIN_SETUP_MESSAGE;
  }

  return message;
}

export async function parseEmailSendError(
  error: unknown,
  defaultMessage: string,
): Promise<string> {
  const message = await parseError(error, defaultMessage);
  return formatEmailErrorMessage(message);
}

export function getEmailSendErrorMessage(
  message: string | undefined,
  defaultMessage: string,
): string {
  return formatEmailErrorMessage(message ?? defaultMessage);
}
